// Common
import RouterFrame from '../../../components/share/RouterFrame.vue'
// Bundles: Internal/Gen
import IntgenVehicleTaskListing from '../../../components/bundles/share/tasksListing/Listing.vue'

const workflowName = 'main_vehicle'
const routePrefix = `intgen_${workflowName}`

export default {
  path: 'generalicrls-pojazd',
  component: RouterFrame,
  meta: {
    title: 'Generali CRLS - pojazd',
    icon: 'generali',
    menuLink: true,
    meta: {
      acl: {
        service: 'intgen',
        action: 'get_main_vehicle_tasks'
      }
    }
  },
  children: [
    {
      path: '',
      component: IntgenVehicleTaskListing,
      name: `${routePrefix}_task_listing`,
      meta: {
        title: 'Lista zleceń - osoba',
        acl: {
          service: 'intgen',
          action: 'get_main_vehicle_tasks'
        }
      }
    }
  ]
}
